import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;
import util from "@/mixins/util";

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            sequence: 0,
            memberKey: "",
            files: [],
            word: "",
            memo: "",
            tag: [],
            sns: [],
            hashTagInput: "",
            ssamsKey: "",
            chatUuid: "",
            memberUuid: "",
            snsTitleInput: "",
            snsLinkInput: "",
            snsKey: '',
            videoFile: [],
            wid: '',
            sid: '',
        };
    },
    validators: {
        sequence: function (value) {
            return Validator.value(value).regex(
                "^[-+|0-9|]+$",
                "숫자만 입력해주세요."
            );
        },
        memberKey: function (value) {
            return Validator.value(value).required("쌤즈 회원을 선택해 주세요.");
        },
        files: function (value) {
            return Validator.value(value).custom(() => {
                if (util.isEmpty(value)) {
                    return "이미지를 선택해주세요.";
                }
            });
        },
        word: function (value) {
            return Validator.value(value);
        },
        memo: function (value) {
            return Validator.value(value);
        },
        tag: function (value) {
            return Validator.value(value);
        },
        sns: function (value) {
            return Validator.value(value);
        },
        ssamsKey: function (value) {
            return Validator.value(value);
        },
        chatUuid: function (value) {
            return Validator.value(value);
        },
        videoFile: function (value) {
            return Validator.value(value)
                .required('파일을 선택해주세요.')
                .custom(() => {
                    if (util.isEmpty(value)) {
                        return "파일을 선택해주세요.";
                    }
                });
        },
        wid: function (value) {
            return Validator.value(value)
        },
        sid: function (value) {
            return Validator.value(value)
        },
    },
    methods: {},
    computed: {},
};
